"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StormPhosphates_exports = {};
__export(StormPhosphates_exports, {
  StormPhosphates: () => StormPhosphates
});
module.exports = __toCommonJS(StormPhosphates_exports);
var import_inventory_enums = require("@cartographerio/inventory-enums");
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
const StormPhosphates = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("StormPhosphates"),
  title: "Phosphates",
  layers: [
    (0, import_topo_map.pointLayer)({
      layerId: (0, import_topo_map.unsafeMapLayerId)("StormPhosphates"),
      title: "Phosphates",
      source: (0, import_core.cartographerSourceWithDefaults)({
        layerId: (0, import_topo_map.unsafeMapLayerId)("StormPhosphates"),
        attribution: []
      }),
      defaultAttribute: "phosphate",
      defaultZOrder: "timestamp",
      attributes: [
        (0, import_topo_map.attributeGroup)({
          label: "Location and Time",
          attributes: [
            (0, import_topo_map.stringAttr)({
              attributeId: "riverName",
              label: "River",
              buckets: "auto"
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "level",
              label: "Level at Nearest Gauge",
              enum: import_inventory_enums.StormPhosphatesLevelEnum,
              markers: {
                [import_inventory_enums.StormPhosphatesLevelEnum.High]: import_topo_map.marker.hue(60),
                [import_inventory_enums.StormPhosphatesLevelEnum.Normal]: import_topo_map.marker.hue(180),
                [import_inventory_enums.StormPhosphatesLevelEnum.Low]: import_topo_map.marker.hue(300)
              }
            }),
            (0, import_topo_map.enumAttr)({
              attributeId: "levelTrend",
              label: "Level Trend at Nearest Gauge",
              enum: import_inventory_enums.StormPhosphatesLevelTrendEnum,
              markers: {
                [import_inventory_enums.StormPhosphatesLevelTrendEnum.Rising]: import_topo_map.marker.hue(60),
                [import_inventory_enums.StormPhosphatesLevelTrendEnum.Steady]: import_topo_map.marker.hue(180),
                [import_inventory_enums.StormPhosphatesLevelTrendEnum.Falling]: import_topo_map.marker.hue(300)
              }
            }),
            (0, import_topo_map.timestampAttr)({
              attributeId: "timestamp",
              label: "Date/Time",
              buckets: "auto"
            }),
            (0, import_topo_map.teamAttr)("teamId", "Team"),
            (0, import_topo_map.surveyAttr)("surveyId", "Site"),
            (0, import_topo_map.attachmentAttr)("photographs", "Photographs")
          ]
        }),
        (0, import_topo_map.attributeGroup)({
          label: "Measurements",
          attributes: [
            (0, import_topo_map.numberAttr)({
              attributeId: "phosphate",
              label: "Phosphates",
              unit: "ppm",
              buckets: [
                (0, import_topo_map.rangeBucket)(0, 0.05, import_topo_map.marker.quality(15 / 20)),
                (0, import_topo_map.rangeBucket)(0.05, 0.25, import_topo_map.marker.quality(10 / 20)),
                (0, import_topo_map.rangeBucket)(0.25, 0.5, import_topo_map.marker.quality(9 / 20)),
                (0, import_topo_map.rangeBucket)(0.5, 0.75, import_topo_map.marker.quality(8 / 20)),
                (0, import_topo_map.rangeBucket)(0.75, 1, import_topo_map.marker.quality(7 / 20)),
                (0, import_topo_map.rangeBucket)(1, 1.25, import_topo_map.marker.quality(6 / 20)),
                (0, import_topo_map.rangeBucket)(1.25, 1.5, import_topo_map.marker.quality(5 / 20)),
                (0, import_topo_map.rangeBucket)(1.5, 1.75, import_topo_map.marker.quality(4 / 20)),
                (0, import_topo_map.rangeBucket)(1.75, 2, import_topo_map.marker.quality(3 / 20)),
                (0, import_topo_map.rangeBucket)(2, 2.25, import_topo_map.marker.quality(2 / 20)),
                (0, import_topo_map.rangeBucket)(2.25, 2.5, import_topo_map.marker.quality(1 / 20)),
                (0, import_topo_map.rangeBucket)(2.5, null, import_topo_map.marker.quality(0 / 20))
              ]
            })
          ]
        })
      ]
    })
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StormPhosphates
});
//# sourceMappingURL=StormPhosphates.js.map
